<template>
 <div id="operationalData-view">
   <div class="content" v-show="isLogin">
     <div class="operationalData-content">
        <section class="section-1">
          <div class="main-title">
            <h1>运营概况</h1>
            <div class="dline"></div>
            <p style="color:#a5a5a5;">截止{{closingDate}}</p>
          </div>
          <table>
            <tr>
              <td class="message">
                <p>{{plantFormData.dateCount}}</p>
                <p>上线运行天数(天)</p>
              </td>
              <td  class="message">
                <p>{{fmoney(plantFormData.bidSum)}}</p>
                <p>累计借款总额(元)</p>
              </td>
              <td  class="message">
                <p>{{fmoney(plantFormData.RealPrincipal)}}</p>
                <p>已还本金(元)</p>
              </td>
              <td  class="message">
                <p>{{fmoney(plantFormData.WaitingAmount)}}</p>
                <p>待还本金(元)</p>
              </td>
            </tr>
            <tr>
              <td  class="message">
                <p>{{fmoney(plantFormData.incomeSum)}}</p>
                <p>历史出借回报总额(元)</p>
              </td>
              <td  class="message">
                <p>{{plantFormData.CountLoanBids}}</p>
                <p>累计交易笔数(笔)</p>
              </td>
              <td  class="message">
                <p>{{plantFormData.CountIncoms}}</p>
                <p>待还余额笔数(笔)</p>
              </td>
              <td  class="message">
                <p>{{plantFormData.people}}</p>
                <p>平台用户数(人)</p>
              </td>
            </tr>
          </table>
        </section>
        <section class="section-2">
          <div class="main-title">
            <h1>月交易信息</h1>
            <div class="dline"></div>
            <p id="month-wrap"><span style="color:#a5a5a5;">统计</span>
              <span class="block">
                <el-date-picker
                  v-model="value4"
                  type="month"
                  value-format="yyyy-MM"
                  :clearable="clearable"
                  :picker-options="pickerOptions0"
                  v-on:change="changDate(value4)">
                </el-date-picker>
                <i class="el-icon-caret-bottom bottomIcon"></i>
              </span>
            </p>
          </div>
          <div class="ebox">
            <div  class="transaction-profile">
              <table>
                <thead>
                  <tr>
                    <th class="tips-title">月交易概况：</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="message">
                      <p>{{fmoney(plantFormData.dealAccount)}}</p>
                      <p>月交易总额(元)</p>
                    </td>
                    <td  class="message">
                      <p>{{ plantFormData.dealNumber ? plantFormData.dealNumber : 0}}</p>
                      <p>月交易笔数(笔)</p>
                    </td>
                  </tr>
                  <tr>
                    <td  class="message">
                      <p>{{fmoney(plantFormData.repaymentNumber)}}</p>
                      <p>月还款总额(元)</p>
                    </td>
                    <td  class="message">
                      <p>{{fmoney(plantFormData.incomeNumber)}}</p>
                      <p>月出借回报(元)</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="project-information">
              <table>
                <thead>
                  <tr>
                      <th class="tips-title">项目占比信息：</th>
                    </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div style="width:490px;height:250px;" class="chart-img">
                        <div id='dealAccount-chart'></div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
        <section class="section-3">
          <div class="main-title">
            <h1>出借用户偏好</h1>
            <div class="dline"></div>
            <p style="color:#a5a5a5;">截止{{closingDate}}</p>
          </div>
          <div class="section-box3">
            <div class="city-message">
              <table>
                <thead>
                  <tr>
                    <th class="tips-title">城市人均出借额Top10：</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div style="width:420px;height:600px;" class="chart-img">
                        <div id='province-chart'></div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="sex-message">
              <table>
                <thead>
                  <tr>
                    <th class="tips-title">性别占比信息：</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div style="width:450px;height:250px;" class="chart-img">
                        <div id='sex-chart'></div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table>
                <thead>
                  <tr>
                    <th class="tips-title">年龄占比信息：</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div style="width:450px;height:250px;" class="chart-img">
                        <div id='age-chart'></div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
     </div>
     <autograph :title="'以上数据均来自普惠理财统计系统'" :isClick="false"></autograph>
   </div>
   <div v-show="!isLogin" class="unlogin">
     <div class="imgBox"></div>
     <p>运营数据信息登录后可见</p>
     <div class="loginBtn" v-on:click="toLogin()">登录</div>
   </div>
 </div>
</template>

<script>
import autograph from '@/components/autograph'
import { DATA_ASYNC } from '@/page/dataReport/operationalData/operationalData_store'
if (typeof window !== 'undefined') {
  var ECharts = require('echarts')
}
export default {
  data () {
    return {
      value4: '',
      closingDate: new Date().format('yyyy-MM-dd HH:mm:ss'),
      monthlyTrading: {},
      clearable: false,
      pickerOptions0: this.set_yysj_disabledDate(),
      ageDatas: [],
      ageOptions: {},
      sexDatas: [],
      sexOptions: {},
      dealAccountData: [],
      dealAccountOption: {},
      provinceList: [],
      provinceOption: {},
      addressdata: [],
      amountdata: [],
      isLogin: false
    }
  },
  computed: {
    plantFormData () {
      return this.$store.state.dataStore.plantFormData
    },
    res () {
      return this.$store.state.dataStore.res
    }
  },
  asyncData ({ store, route }) {
    return store.dispatch(DATA_ASYNC)
  },
  mounted () {
    var that = this
    this.verifyLogin().then((res) => {
      that.isLogin = true
      if (this.value4 === '') {
        var myDate = new Date()
        // new Date(myDate.setMonth(myDate.getMonth() - 1)).format('yyyy-MM')
        this.value4 = new Date(myDate.setMonth(myDate.getMonth() - 1)).format('yyyy-MM')
        this.getOperationalData(this.value4)
      } else {
        that.isLogin = false
        this.getOperationalData(this.value4)
      }
    }).catch(() => {
    })
  },
  methods: {
    filterData (res) {
      this.ageDatas = [
        {value: res.data.userPreference.ageAvg.ageGreaterThan60, name: '60岁及以上'},
        {value: res.data.userPreference.ageAvg.ageLessThan50GreaterThan59, name: '50~59岁'},
        {value: res.data.userPreference.ageAvg.ageLessThan40GreaterThan49, name: '40~49岁'},
        {value: res.data.userPreference.ageAvg.ageLessThan30GreaterThan39, name: '30~39岁'},
        {value: res.data.userPreference.ageAvg.ageLessThan30, name: '30岁以下'}
      ]
      this.sexDatas = [
        {value: res.data.female, name: '女性'},
        {value: res.data.man, name: '男性'}
      ]
      this.ageOptionData(this.ageDatas)
      this.sexOptionData(this.sexDatas)
      var dealData = res.data.dealAccountScale
      this.dealAccountData = this.dealList(dealData, ['name', 'value'])
      this.dealAccountOptionData(this.dealAccountData)
      this.provinceList = res.data.userPreference.provinceList
      this.dealProvinceListData(this.provinceList)
      this.cityOptionData()
    },
    getOperationalData (val) {
      this.$store.dispatch(DATA_ASYNC, { date: val }).then((res) => {
        this.filterData(res)
      })
    },
    set_yysj_disabledDate () {
      return {
        disabledDate: (time) => {
          var tempTime = new Date(time).format('yyyy-MM')
          var startTime = '2013-11'
          var endTime = new Date().format('yyyy-MM')
          return endTime <= tempTime || startTime >= tempTime
        }
      }
    },
    dealProvinceListData (addressTemp) {
      if (addressTemp !== []) {
        var _this = this
        var list = addressTemp.sort(function (a, b) {
          var sort1 = a.AVG_BID
          var sort2 = b.AVG_BID
          return sort2 - sort1
        })
        _this.addressdata = []
        _this.amountdata = []
        list.forEach((val, index) => {
          _this.addressdata.push(index + 1 + '.' + val.P)
          _this.amountdata.push(list[index])
        })
        _this.amountdata = _this.dealAmountdata(_this.amountdata, ['name', 'value'])
        var ads = ['云南', '宁夏', '海南', '广西', '新疆', '青海', '辽宁', '内蒙', '贵州', '湖南']
        var lens = list.length
        if (lens < 10) {
          for (var i = 0; i < 10 - lens; i++) {
            _this.addressdata.push(_this.addressdata.length + 1 + '.' + ads[i])
            _this.amountdata.push(0)
          }
        }
        _this.addressdata.reverse()
        _this.amountdata.reverse()
      } else {
        return false
      }
    },
    dealList (arr, key) { /* 处理数据 - ['name', 'value'] */
      let newArr = []
      arr.forEach((item, index) => {
        let newObj = {}
        for (var i = 0; i < key.length; i++) {
          newObj[key[i]] = item[Object.keys(item)[i]]
        }
        newArr.push(newObj)
      })
      return newArr
    },
    dealAmountdata (arr, key) { /* 处理城市人均数据 - ['name', 'value'] */
      let newArr = []
      arr.forEach((item, index) => {
        let newObj = {
          name: item.P,
          value: item.AVG_BID
        }
        newArr.push(newObj)
      })
      return newArr
    },
    ageOptionData (obj) { /* 年龄echarts option */
      let myChart = ECharts.init(document.getElementById('age-chart'))
      this.ageOptions = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}'
        },
        legend: {
          orient: 'vertical',
          x: 250,
          y: 10,
          padding: [20, 2],
          itemGap: 20,
          align: 'left',
          backgroundColor: 'rgba(0,0,0,0)',
          itemWidth: 6,
          itemHeight: 6,
          formatter: function (name) {
            var total = 0
            var target = 0
            for (var i = 0, l = obj.length; i < l; i++) {
              total += obj[i].value
              if (obj[i].name === name) {
                target = obj[i].value
              }
            }
            return name + ' ' + Math.round(((target / total) * 100)) + '%'
          }
        },
        color: [
          '#e45359',
          '#f5777c',
          '#ff989c',
          '#ffb7ba',
          '#ffd5d7'
        ],
        series: [
          {
            name: '访问来源',
            type: 'pie',
            center: [100, 100],
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '30',
                  fontWeight: 'bold'
                },
                formatter: '{d}%'
              }
            },
            data: obj
          }
        ]
      }
      myChart.setOption(this.ageOptions)
    },
    sexOptionData (obj) { /* 性别echarts option */
      let myChart = ECharts.init(document.getElementById('sex-chart'))
      this.sexOptions = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}:<br/> ({d}%)'
        },
        series: [
          {
            name: '性别占比',
            type: 'pie',
            center: ['50%', '50%'],
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                formatter: '  {b} \n{br|}\n {per|{d}%}  ',
                padding: [0, 7],
                rich: {
                  a: {
                    color: '#999',
                    lineHeight: 22,
                    align: 'center'
                  },
                  b: {
                    fontSize: 16,
                    lineHeight: 33
                  },
                  per: {
                    color: '#222',
                    padding: [1, 4]
                  }
                }
              }
            },
            data: obj
          }
        ]
      }
      myChart.setOption(this.sexOptions)
    },
    dealAccountOptionData (obj) { /* 项目信息echarts option */
      let myChart = ECharts.init(document.getElementById('dealAccount-chart'))
      this.dealAccountOption = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}:<br/> ({d}%)'
        },
        legend: {
          orient: 'vertical',
          x: 250,
          y: 10,
          padding: [20, 2],
          itemGap: 20,
          align: 'left',
          backgroundColor: 'rgba(0,0,0,0)',
          itemWidth: 6,
          itemHeight: 6,
          data: this.dealListKey(obj),
          formatter: function (name) {
            var total = 0
            var target = 0
            for (var i = 0, l = obj.length; i < l; i++) {
              total += obj[i].value
              if (obj[i].name === name) {
                target = obj[i].value
              }
            }
            return name + ' ' + Math.round(((target / total) * 100)) + '%'
          }
        },
        color: [
          '#fcaf5d',
          '#e0585c',
          '#67a3e9',
          '#b1ce4e',
          '#7cc576'
        ],
        series: [
          {
            name: '访问来源',
            type: 'pie',
            center: [100, 100],
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '30',
                  fontWeight: 'bold'
                },
                formatter: '{d}%'
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: obj
          }
        ]
      }
      myChart.setOption(this.dealAccountOption)
    },
    cityOptionData () { /* 城市人均echarts option */
      var _this = this
      let myChart = ECharts.init(document.getElementById('province-chart'))
      this.provinceOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: 10,
          right: '4%',
          top: 0,
          containLabel: true
        },
        xAxis: {
          type: 'value',
          axisLabel: {show: false},
          axisLine: {show: false},
          axisTick: {show: false},
          splitLine: {show: false}
        },
        yAxis: [
          {
            type: 'category',
            axisLine: {show: false},
            axisTick: {show: false},
            splitLine: {show: false},
            nameGap: 20,
            boundaryGap: ['20%', '20%'],
            data: _this.addressdata
          },
          {
            type: 'category',
            axisLine: {show: false},
            axisTick: {show: false},
            splitLine: {show: false},
            nameGap: 20,
            boundaryGap: ['20%', '20%'],
            data: _this.amountdata.map((val, key, arr) => {
              return _this.fmoney(val.value)
            })
          }
        ],
        series: [
          {
            name: '城市人均出借额',
            type: 'bar',
            itemStyle: {
              normal: {
                color: '#ffc279'
              }
            },
            barWidth: 20,
            barGap: '60%',
            data: _this.amountdata
          }
        ]
      }
      myChart.setOption(this.provinceOption)
    },
    dealListKey (obj) {
      var arr = []
      obj.forEach((item) => {
        arr.push({name: item.name})
      })
      return arr
    },
    changDate (val) {
      this.getOperationalData(val)
    }
  },
  components: {
    'autograph': autograph
  }
}
</script>

<style lang="less">
#operationalData-view{
  background: #f5f5f5;
  padding-bottom: 20px;
  .unlogin{
    width: 1200px;
    height: 500px;
    padding-top: 100px;
    margin: 0 auto 0;
    background: #fff;
    .imgBox{
      width: 150px;
      height: 134px;
      background: url(../../../assets/images/kongstatus.png);
      background-size: 100% 100%;
      margin: 100px auto 15px;
    }
    p{
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
    }
    .loginBtn{
      width: 124px;
      height: 36px;
      border: 1px solid #E6382C;
      border-radius: 4px;
      margin: 60px auto 0;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #E6382C;
      cursor: pointer;
    }
  }
  .content{
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    .operationalData-content{
      width: 1000px;
      margin: 0 auto;
      .section-1 {
        border-bottom: 1px solid #eee;
      }
      .section-2{
        border-bottom: 1px solid #eee;
        #month-wrap{
          width: 248px;
          margin-left: 198px;
          .block{
            position: relative;
            .bottomIcon{
              width: 12px;
              position: absolute;
              right: 121px!important;
              top: 2px;
            }
            .el-input__inner{
              border:none;
              width: 70%;
              font-size: 12px;
              color: #a5a5a5;
            }
          }
        }
        .ebox{
          width: 100%;
          display: flex;
          justify-content: space-between;
          flex-wrap: nowrap;
          .transaction-profile{
            display: inline-block;
            width: 420px;
            min-height: 300px;
            margin-bottom: 10px;
          }
          .project-information{
            display: inline-block;
            width: 420px;
            min-height: 300px;
            margin-bottom: 10px;
            td {
              width: 490px;
              height: 250px;
              .chart-img{
                >div{
                  width: 100%;
                  height: 250px;
                }
              }
            }
          }
        }
      }
      .section-3{
        margin-bottom: 140px;
        .section-box3{
          width: 100%;
          display: flex;
          justify-content: space-between;
          flex-wrap: nowrap;
          .city-message, .sex-message{
            display: inline-block;
            height:500px;
          }
          .city-message{
            width: 420px;
            td{
              width: 100%;
              height: 600px;
              .chart-img{
                >div{
                  width: 100%;
                  height: 600px;
                }
              }
            }
          }
          .sex-message{
            width: 450px;
            td{
              width: 450px;
              height: 250px;
              .chart-img{
                >div{
                  width: 100%;
                  height: 250px;
                }
              }
            }
          }
        }
      }
      .tips-title {
        text-align: left;
        height: 50px;
        letter-spacing: 2px;
        font-size: 14px;
        font-weight: normal;
        &::before {
          content: "";
          display: inline-block;
          height: 12px;
          width: 4px;
          background: #fc4d2d;
          margin-right: 5px;
          position: relative;
          top: 1px;
        }
      }
      table {
        width: 100%;
        margin: 0 auto;
        margin-bottom: 80px;
        td {
          height: 112px;
        }
        .message {
          p:first-child{
            font-size: 24px;
            margin-bottom: 6px;
            font-family: 'DINBold'!important;
          }
          p:nth-child(2){
            font-size: 14px;
            color: #a5a5a5;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/dataReport/operationalData/operationalData.vue